@for (area of areasWithIssues; track area.name) {
  <div class="issue-group"
       data-testid="container-issue-group">
    <h4 class="area-header body-md-semibold"
        data-testid="text-area-name">{{ area.name }}</h4>
    <div class="issues-list">
      @for (issue of area.issues; track issue.id) {
        <a class="issue-card"
           [href]="getIssueLink(area, issue)"
           (click)="viewIssue(area, issue, $event)"
           data-testid="btn-issue-card">
          @if(issuesSavingMap[issue.identifier]) {
            <i class="pi pi-spinner pi-spin"></i>
          }
          @else {
            @if (issue.isConfirmedByHomeowner) {
              <i class="pi pi-check-circle issue-confirmed-icon"
                 data-testid="icon-confirmed-issue"></i>
            } @else if (issue.postCompleteStatus) {
                <img class="area-status-completed"
                  src="assets/icons/material-construction.svg"
                  alt="Completed" />
            }
            @else {
              <span class="issue-unresolved-spacer"></span>
            }
          }
          <span class="issue-text body-lg-regular">{{ issue.text }}</span>
          <i class="pi pi-chevron-right issue-chevron"></i>
        </a>
      }
    </div>
  </div>
}